import * as requestFromServer from "./PackageManagementApis";
import { UISlice } from "../UISlice";
import { PackageManagementSlice, setLoading } from "./PackageManagementSlice";

const { actions: PackageManagementActions } = PackageManagementSlice;
const { actions: UIActions } = UISlice;

export const FetchPackageManagement =
  (getPackageBy = "") =>
  (dispatch) => {
    dispatch(UIActions.openLoader());
    dispatch(setLoading(true));

    let fetchFunction;
    switch (getPackageBy) {
      case "partners":
        fetchFunction = requestFromServer.fetchPackageManagementDataByPartners;
        break;
      case "categories":
        fetchFunction =
          requestFromServer.fetchPackageManagementDataByCategories;
        break;
      default:
        fetchFunction = requestFromServer.fetchPackageManagementDataByPartners;
        break;
    }

    return fetchFunction(getPackageBy)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            PackageManagementActions.setPackageManagementData({
              data: response.data.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(PackageManagementActions.catchError(error));
      })
      .finally(() => {
        dispatch(UIActions.closeLoader());
        dispatch(setLoading(false));
      });
  };
